import React, { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";

import { Images } from "../../../config/images";
import { useTeacherSetPassword } from "../../../hooks/teacher/useTeacherSetPassword";
import { useStudentSetPassword } from "../../../hooks/student/useStudentSetPassword";

import CustomPasswordInput from "../../common/CustomPasswordInput";

const SetPasswordForm = ({ type }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("token");
  const email = searchParams.get("email");

  const teacherHook = useTeacherSetPassword();
  const studentHook = useStudentSetPassword();

  const inputRef = useRef();

  // Select correct hook based on type
  const { loading, error, setTeacherPassword, setStudentPassword } =
    type === "schoolteacher" ? teacherHook : studentHook;

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const initialValues = {
    password: "",
    password_confirmation: "",
  };

  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters")
      .matches(/[A-Z]/, "Must contain an uppercase letter")
      .matches(/[a-z]/, "Must contain a lowercase letter")
      .matches(/[0-9]/, "Must contain a number")
      .matches(/[@$!%*?&^#]/, "Must contain a special character"),
    password_confirmation: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Please confirm your password"),
  });

  const handleSubmit = async (values) => {
    const payload = {
      email,
      token,
      password: values.password,
      password_confirmation: values.password_confirmation,
    };

    console.log("Sending payload:", payload);

    const submitFunction =
      type === "schoolteacher" ? setTeacherPassword : setStudentPassword;

    submitFunction(payload, () => {
      toast.success("Password has been set successfully!");
      navigate(type === "schoolteacher" ? "/login" : "/login");
    });
  };

  return (
    <section className="tenant-login-wrapper">
      <div className="tenant-login-card">
        <div className="tenant-login-logo">
          <img src={Images.Logo} alt="logo" onClick={() => navigate("/")} />
          <p className="tenant-login-title">Set Password</p>
        </div>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className="d-flex flex-column gap-3">
              <CustomPasswordInput
                label="Password"
                name="password"
                type="password"
                placeholder="Enter your password"
                ref={inputRef}
              />
              <CustomPasswordInput
                label="Confirm Password"
                name="password_confirmation"
                type="password"
                placeholder="Confirm your password"
              />

              {error && <div className="custom-error text-center">{error}</div>}

              <button
                type="submit"
                className="custom-primary-button"
                disabled={loading || isSubmitting}
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </section>
  );
};

export default SetPasswordForm;
